import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDateRangePicker } from '@angular/material/datepicker';
import moment from 'moment';
import { FilterOptionType } from 'src/app/library/enums/filters/filter.enum';
import { IFilter } from 'src/app/library/interfaces/filters/filter';
import { IFilterOption } from 'src/app/library/interfaces/filters/filter-option';
import { FilterService } from 'src/app/library/services/filter/filter.service';

@Component({
    selector: 'filter-single-select-date-range',
    templateUrl: './filter-single-select-date-range.component.html',
    styleUrls: ['./filter-single-select-date-range.component.scss']
})
export class FilterSingleSelectDateRangeComponent implements OnInit {
    @ViewChild('rangePicker') rangePickerElement: MatDateRangePicker<Date>;

    @Input() filter: IFilter;

    public customDateRange: UntypedFormGroup;
    public dataTypeEnum = FilterOptionType;
    private _customOptionHeading = 'Custom';

    constructor(private filterService: FilterService) {}

    ngOnInit() {
        this.loadCustomOption();
        this.loadForm();
        this.listeners();
    }

    public removeFilter() {
        this.filterService.removeFilter(this.filter);
        this.filterService.filterChangeEvent();
    }

    public selectOption(obj: IFilterOption) {
        let currentVal = this.filterService.filterConfig;
        if (obj.heading == 'Custom') {
            let filterVal = currentVal.filters.find(
                e => e.field == this.filter.field
            );
            filterVal.options.forEach(e => (e.isSelected = false));
            let filterOption = this.filter.options.find(
                e => e.heading == this._customOptionHeading
            );
            if (filterOption) {
                filterOption.isSelected = true;
                this.filterService.filterConfig = currentVal;
                this.rangePickerElement.open();
            }
        } else {
            this.customDateRange.reset();
            let filterVal = currentVal.filters.find(
                e => e.field == this.filter.field
            );
            if (filterVal) {
                filterVal.selected = true;
                filterVal.options.forEach(e => (e.isSelected = false));
                let optionVal = filterVal.options.find(
                    e => e.value == obj.value
                );
                if (optionVal) {
                    optionVal.isSelected = true;
                    this.filterService.filterConfig = currentVal;
                    this.filterService.filterChangeEvent();
                }
            }
        }
    }

    private customOption(obj: IFilterOption) {
        let currentVal = this.filterService.filterConfig;
        let filterVal = currentVal.filters.find(
            e => e.field == this.filter.field
        );
        if (filterVal) {
            if (obj.value) {
                let filterOption = this.filter.options.find(
                    e => e.heading == this._customOptionHeading
                );
                if (filterOption) {
                    filterOption.value = obj.value;
                    this.filterService.filterConfig = currentVal;
                    this.filterService.filterChangeEvent();
                }
            }
        }
    }

    private listeners() {
        this.customDateRange.valueChanges.subscribe(
            (data: { begin: Date; end: Date }) => {
                let filterOption = this.filter.options.find(
                    e => e.heading == this._customOptionHeading
                );
                if (filterOption) {
                    if (data.begin && data.end) {
                        const dateApiVal = `${moment(data.begin)
                            .format('DD-MM-YYYY')
                            .toString()}:${moment(data.end)
                            .format('DD-MM-YYYY')
                            .toString()}`;
                        filterOption.value = dateApiVal;
                        this.customOption(filterOption);
                    } else {
                        filterOption.value = null;
                    }
                }
            }
        );
    }

    private loadForm() {
        this.customDateRange = new UntypedFormGroup({
            begin: new UntypedFormControl(),
            end: new UntypedFormControl()
        });
    }

    private loadCustomOption() {
        const filterOption = this.filter.options.find(
            e => e.heading == this._customOptionHeading
        );
        if (!filterOption) {
            this.filter.options.push({
                heading: this._customOptionHeading,
                pictureUrl: null,
                subheading: '',
                value: null,
                isSelected: false
            });
        }
    }

    public customValueDisplay(val: string) {
        if (!val) return null;
        let dateVals = val.split(':');
        if (dateVals.length != 2) return null;
        let start = moment(dateVals[0], 'DD-MM-YYYY').format('DD MMMM YYYY');
        let end = moment(dateVals[1], 'DD-MM-YYYY').format('DD MMMM YYYY');
        return `${start} - ${end}`;
    }

    get selectedOption() {
        return this.filter.options?.find(e => e.isSelected);
    }

    get isMostRecentFilter() {
        return (
            this.filterService.mostRecentFilter()?.field == this.filter.field
        );
    }

    get addedFilterLength() {
        return this.filterService.filterConfig.filters.filter(e => e.added)
            .length;
    }
}
